<template>
  <v-footer id="ca-footer" class="simple pa-0" :fixed="false">
    <v-container class="container--fluid" >
      <v-row justify="space-between">
        <span class="links-modals-footer">
          <a v-if="!user" @click="$emit('update:show_modal_registro', true)">Registro</a>
        </span>
        <span class="trade-mark">ConsorcioAbierto
          <sup>&reg;</sup>
          {{ new Date().getFullYear() }}. Todos los derechos reservados.
        </span>
      </v-row>
    </v-container>
  </v-footer>
</template>

<script>
export default {
  props: {
    show_modal_registro: {type: Boolean, default: false}
  },
  computed: {
    user() {
      return this.$store.getters.user;
    }
  }
};
</script>

<style lang="scss">
#ca-footer {
  background-color: color(gris);
  color: color(celeste-claro);
  .container {
    padding: 0 15px;
  }
  a {
    color: color(blanco);
    text-decoration: underline;
  }
  height: 30px;
  font-size: 10px;
}
</style>